module.exports = __webpack_public_path__ + "img/119ne.436f298b.svg";